const roundToFixed = (num, decimalPlaces) => {
  const mult = Math.pow(10, decimalPlaces);
  return (Math.round(num * mult) / mult).toFixed(decimalPlaces);
};

const numberWithCommas = (x) => {
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export const formatNumber = (number) => {
  return numberWithCommas(roundToFixed(number, 2))
}



// WEBPACK FOOTER //
// ./src/common/formatNumber.js